import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { closeDialog } from '../../../store/modules/dialog';
import Dialog from '../Dialog';
import { useTranslation } from 'react-i18next';
import GridLayout from '../../common/GridLayout';
import { useState } from 'react';
import { genPWCShareYourOpinion } from '../../plugin/pwc/pwcApis';
import { insertActiveLink } from '../../plugin/activeLink';
import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';
import Checkbox from '../../common/Checkbox';
import { noTextSelect } from '../../common/CssCommon';
import { useGenNotificationPromise } from '../../notification/Notification';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  width: 529px;
  height: 282px;
  padding: 24px;
  ${noTextSelect}
`;

const TitleWrapper = styled.div`
  height: 29px;
  font-size: 20px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-bottom: 24px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
`;

const ItemLabel = styled.label`
  height: 100%;
  width: fit-content;
`;

const ItemName = styled.span`
  height: 25px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-left: 6px;
`;

const User_List = [
  {
    id: 'minjun',
    name: '김민준'
  },
  {
    id: 'minjae',
    name: '장민재'
  },
  {
    id: 'jihun',
    name: '유지훈'
  },
  {
    id: 'hyunwoo',
    name: '강현우'
  },
  {
    id: 'yeeun',
    name: '이예은'
  }
];

export default function ActiveLinkShareOpinionDialog({ isShow, userList = User_List }) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [checkList, setCheckList] = useState(['minjun', 'jihun', 'yeeun']);
  const poSDKContextState = usePOWebofficeSDKState();
  const notificationPromise = useGenNotificationPromise();

  const handleCheckBox = (event, userID) => {
    const checked = event.currentTarget.checked;
    if (checked) {
      setCheckList([...checkList, userID]);
    } else {
      setCheckList(checkList.filter((item) => item !== userID));
    }
  };

  const onClickSubmit = () => {
    const names = checkList.map((ele) => {
      return User_List.filter((User) => {
        return User.id === ele;
      })[0].name;
    });

    if (names && names.length > 0) {
      genPWCShareYourOpinion(names)
        .then((pwcURL) => insertActiveLink(poSDKContextState, pwcURL))
        .then(() => {
          dispatch(closeDialog());
        });
    } else {
      notificationPromise({
        title: i18n.t('Common.Notification'),
        message: i18n.t('ActiveLink.ShareOpinionErrorMessage'),
        btn: {
          confirm: {
            text: i18n.t('Common.Confirm')
          }
        },
        showCloseBtn: false
      });
    }
  };

  return (
    <Dialog isNoHeader isShow={isShow}>
      <DialogBody>
        <TitleWrapper>{t('ActiveLink.ShareOpinion')}</TitleWrapper>
        <ContentsWrapper>
          <GridLayout column={3} gap={6}>
            {userList.map((user) => {
              return (
                <ItemLabel>
                  <Checkbox
                    checked={checkList.includes(user.id)}
                    size={18}
                    onChange={(e) => handleCheckBox(e, user.id)}
                  />
                  <ItemName>{user.name}</ItemName>
                </ItemLabel>
              );
            })}
          </GridLayout>
        </ContentsWrapper>
        <ActiveLinkDialogFooter onSubmit={onClickSubmit}></ActiveLinkDialogFooter>
      </DialogBody>
    </Dialog>
  );
}
